import messageSignerApiDefinition from './api.js';
import messageSignerDefinition from './module.js';
const messageSigner = () => ({
    id: 'messageSigner',
    definitions: [
        { definition: messageSignerDefinition },
        { definition: messageSignerApiDefinition },
    ],
});
export default messageSigner;
